<template>
  <div>
    <van-sticky>
      <van-nav-bar :title="'运动会管理(' + athletList.length + ')'" left-text="返回" left-arrow @click-left="onClickLeft">
        <template #right>
          <van-popover v-model="showPopover" trigger="click" :actions="actions" theme="dark" placement="bottom-end"
            @select="onOperate">
            <template #reference>
              <van-icon name="ellipsis" size="18" />
            </template>
          </van-popover>

        </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item @change="dropdownItemChange" v-model="gender" :options="genders" />
        <van-dropdown-item @change="dropdownItemChange" v-model="sgroup" :options="sgroups" />
        <van-dropdown-item @change="dropdownItemChange" v-model="category" :options="categorys" />
        <van-dropdown-item @change="dropdownItemChange" v-model="progress" :options="progresses" />
      </van-dropdown-menu>

    </van-sticky>

    <div class="promotion" style="margin: 5px;text-align: right">
      <van-button v-show="result.length != 0" @click="select" size="small"
        icon="https://img01.yzcdn.cn/vant/user-active.png" type="info" plain>晋级({{ result.length }})
      </van-button>
    </div>
    <div class="delete" style="margin: 5px;text-align: right">
      <van-button v-show="result.length != 0" @click="del" size="small" type="warning">删除({{ result.length }})
      </van-button>

    </div>
    <div class="selectAllOrNot" style="margin: 5px;text-align: right">
      <van-button v-show="athletList.length != 0" @click="selectAllOrNot" size="small" type="info">{{
        this.result.length != this.athletList.filter(v => v.pass != 0).length ? '全选' : '取消全选'
      }}
      </van-button>
    </div>
    <van-checkbox-group v-model="result" style="margin: 0 10px">
      <van-cell-group>
        <van-cell v-for="(item, index) in athletList" clickable :key="item.id"
          :label="`第${item.ranks}名 成绩一:[ ${item.score1} ] 成绩二:[ ${item.score2} ]`" @click="toggle(index)">
          <template #title>
            {{ `${item.sname} ${item.groupNumber}组 ${item.dc}道` }}
            <van-tag v-if="item.pass == 0" type="danger">犯规</van-tag>
            <van-tag v-if="item.pass == 1 && item.process > 7" type="primary">已发布</van-tag>
          </template>

          <template #right-icon>
            <van-checkbox :name="item" ref="checkboxes" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>

    <van-action-sheet v-model="actionSheetShow" title="运动会报名表">
      <div class="content">
        <div style="text-align: center">
          <a target="_blank"
            href="https://files.sports.hhstu.club/%E8%BF%90%E5%8A%A8%E4%BC%9A%E6%8A%A5%E5%90%8D%E8%A1%A8%E6%A8%A1%E6%9D%BF2023%E7%AC%AC%E4%B8%80%E7%89%88.xlsx">
            <van-button style="margin-bottom: 25px" round block type="primary">报名表上传模板下载</van-button>
          </a>
          <van-uploader accept=".xls,.xlsx" v-model="fileList" :max-count="1" :before-read="before_read"
            :after-read="after_read" :before-delete="delete_file">
            <van-button round block icon="plus" type="primary">报名表上传</van-button>
          </van-uploader>

          <div v-for="(items, key, index) in repeatability" :key="index">
            <van-divider :style="{ color: '#f40', borderColor: '#000' }">{{
              key
            }}项目重复学号
            </van-divider>
            <van-cell :border="false" v-for="(item, index) in items" :key="index" :title="item.key"
              :value="'重复' + item.value + '次'">
              <template #right-icon>
                <van-button plain type="default" size="mini" @click="copyTextToClipboard(item.key)">复制</van-button>
              </template>
            </van-cell>
          </div>
          <div v-for="(items, key, index) in uploadCheck" :key="index">
            <van-divider :style="{ color: '#f40', borderColor: '#000' }">{{
              key
            }}
            </van-divider>
            <van-cell :border="false" v-for="item in items" :key="item" :title="key" :value="'第' + item + '行'">
            </van-cell>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-dialog v-model="show" :before-close="beforeClose" confirmButtonText="确定晋级" :title="`晋级名单(${result.length})人`"
      show-cancel-button>
      <div style="text-align: center">{{ '项目名:' + getTitle() }}</div>
      <van-cell title="赛程:">
        <template #right-icon>
          <van-radio-group v-model="new_progress" direction="horizontal">
            <van-radio v-if="progress != '复赛'" name="复赛">复赛</van-radio>
            <van-radio name="决赛">决赛</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <van-cell title="组别:">
        <template #right-icon>
          <van-stepper v-model="new_group" integer min="1" />
        </template>
      </van-cell>
      <div :style="'height: ' + (result.length > 7 ? 400 : 50 * result.length) + 'px;overflow: scroll'">
        <van-field v-for="(item, index) in result" v-model="item.new_dc" :key="item.id"
          :label="`${index + 1} ${item.sname}`" type="number" placeholder="请输入道次" input-align="right" />
      </div>
    </van-dialog>
    <van-dialog v-model="delShow" :title="`确认要删除以下${delList.length}人吗`" @confirm="clickDel" show-cancel-button>
      <div style="overflow: scroll;height: 300px">
        <van-cell-group style="margin: 10px;">
          <van-cell v-for="(item, index) in delList" :key="item.id"
            :title="`${index + 1} ${item.sname} ${item.dep} ${item.groupNumber}组 ${item.dc}道`" />
        </van-cell-group>
      </div>
    </van-dialog>
    <van-dialog v-model="addAthletesShow" title="添加运动员" show-cancel-button :before-close="beforeAddAthletesClose">
      <div style="overflow: scroll;height: 300px">

        <van-cell title="运动员选择" @click="searchStudentShow = true"
          :value="`${newAthletes.Athletes.name} ${newAthletes.Athletes.num} ${newAthletes.Athletes.gender} `" />
        <van-field v-model="newAthletes.Athletes.number" label="运动员号码" placeholder="运动员号码" />
        <van-cell title="运动员道次">
          <van-stepper theme="round" min="0" max="50" v-model="newAthletes.daoci" integer />
        </van-cell>
        <van-cell title="项目性别" :value="newAthletes.Athletes.gender + (newAthletes.Athletes.gender != '' ? '子' : '')" />
        <van-cell title="参赛单位" @click="selectMultiTypes('dep')" :value="newAthletes.dep" />
        <van-cell title="项目组别" @click="selectMultiTypes('sgroup')"
          :value="newAthletes.sgroup + (newAthletes.sgroup != '' ? '组' : '')" />
        <van-cell title="项目类别" @click="selectMultiTypes('category')" :value="newAthletes.category" />
        <div v-if="newAthletesTitles.length > 0">
          <van-divider>快捷选择</van-divider>
          <div v-for="item in newAthletesTitles" :class="item == newAthletesTitle ? 'classesSelected' : ''"
            style="text-align: center;margin: 30px;font-size: 10px"
            @click="newAthletesTitle == '' ? newAthletesTitle = item : newAthletesTitle = ''">{{ item }}
          </div>
        </div>
        <div v-if="newAthletesTitle == ''">
          <van-cell title="项目类型" @click="selectMultiTypes('types')" :value="newAthletes.types" />
          <van-cell title="项目进度" @click="selectMultiTypes('progress')" :value="newAthletes.progress" />
          <van-cell title="项目内第几组">
            <van-stepper theme="round" min="1" max="100" v-model="newAthletes.group_number" integer />
          </van-cell>
          <van-cell title="项目序号">
            <van-stepper theme="round" min="1" max="1000" v-model="newAthletes.serial" integer />
          </van-cell>
        </div>
        <van-divider>参与项目标题预览</van-divider>
        <div style="text-align: center;margin: 20px 0;">
          <div v-if="newAthletesTitle == ''">
            {{
              '第' + newAthletes.serial + '组 ' + newAthletes.Athletes.gender + '子' + newAthletes.sgroup + '组' +
              newAthletes.category + newAthletes.progress + '第' + newAthletes.group_number + '组'
            }}
          </div>
          <div v-else>{{ newAthletesTitle }}</div>
        </div>
        <!--        <van-button plain type="default" size="mini" @click="searchStudentShow=true">复制</van-button>-->
      </div>
    </van-dialog>
    <van-action-sheet v-model="multiTypeShow" :title="multiTypeName + '选择'"
      @closed="multiTypeShowClose(multiTypeName_tag)">
      <div class="classesContent">
        <van-field v-model="multiType" :label="multiTypeName" :placeholder="'请输入' + multiTypeName" />
        <van-cell-group inset>
          <van-cell :class="item.value == multiType ? 'classesSelected' : ''" :title="item.value" :value="item.value"
            v-for="(item, index) in multiTypes" @click="multiType = item.value" :key="index" />
        </van-cell-group>
      </div>
    </van-action-sheet>
    <search-student :searchStudentShow="searchStudentShow" @closed="searchStudentShow = false"
      @selectedSearchStu="selectedSearchStu"></search-student>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Popup,
  Sticky,
  Cascader,
  Field,
  Icon,
  Popover,
  Dialog,
  Toast,
  ActionSheet,
  Button,
  Uploader,
  Cell,
  CellGroup,
  Divider,
  Tab, Tabs,
  DropdownMenu,
  DropdownItem, Checkbox, CheckboxGroup, RadioGroup, Radio, Stepper, Tag
} from 'vant';
import { upLoadStuSportsMeet } from "@/network/upLoader";
import {
  GetSportsMeetGroup,
  GetSportsMeetAthletList,
  SportsMeetPromotion,
  DelAthletByIdList,
  GetSportsMeetMultiTypes,
  AddAthletesController
} from "../../network/sports_meet";
import searchStudent from "@/components/content/SearchStudent/SearchStudent.vue";

Vue.use(NavBar)
Vue.use(Popup)
Vue.use(Sticky)
Vue.use(Cascader)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(ActionSheet)
Vue.use(Button)
Vue.use(Uploader)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Divider)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Stepper)
Vue.use(Tag)
export default {
  name: "SportsMeet",
  components: {
    searchStudent
  },
  data() {
    return {
      // Popover
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '运动会报名表' }, { text: '导出秩序册' }, { text: '导出号码对照表' }, { text: '下载数据' }, { text: '下载当前条件数据' }, { text: '添加运动员' }],
      // dropdown menu
      gender: "男",
      sgroup: "甲",
      category: '100米',
      progress: '预赛',
      genders: [
        // {text: '男', value: '男'},
        // {text: '女', value: '女'},
      ],
      sgroups: [
        // {text: '甲', value: '甲'},
        // {text: '乙', value: '乙'},
        // {text: '丙', value: '丙'},
      ],
      categorys: [
        // {text: '100米', value: '100米'},
        // {text: '200米', value: '200米'},
        // {text: '400米', value: '400米'},
        // {text: '800米', value: '800米'},
        // {text: '1500米', value: '1500米'},
        // {text: '3000米', value: '3000米'},
        // {text: '跳高', value: '跳高'},
        // {text: '跳远', value: '跳远'},
        // {text: '三级跳远', value: '三级跳远'},
        // {text: '铅球', value: '铅球'},
      ],
      progresses: [
        // {text: '预赛', value: '预赛'},
        // {text: '复赛', value: '复赛'},
        // {text: '决赛', value: '决赛'},
      ],
      deps: [
        // {text: '预赛', value: '预赛'},
        // {text: '复赛', value: '复赛'},
        // {text: '决赛', value: '决赛'},
      ],
      // action sheet
      actionSheetShow: false,

      athletList: [],
      result: [],
      // upload
      fileList: [],

      repeatability: [],
      uploadCheck: [],

      // dialog
      show: false,
      promotionMenber: [],
      new_progress: "复赛",
      new_group: 1,

      delShow: false,
      delList: [],
      // addAthletes dialog
      addAthletesShow: false,
      newAthletes: {
        Athletes: {
          name: '',
          num: '',
          gender: '',
          number: '',
        },
        daoci: 0,
        dep: '',
        sgroup: '',
        types: '',
        category: '',
        progress: '',
        group_number: 1,
        serial: 1
      },
      newAthletesTitles: [],
      newAthletesTitle: '',
      // components
      searchStudentShow: false,

      //multiTypeShow
      multiTypeShow: false,
      multiType: "",
      multiTypeName: "",
      multiTypeName_tag: "",
      multiTypes: [],
    }
  },
  mounted() {
    this.GetSportsMeetMultiTypes();
    this.getSportsMeetGroup();
    this.getSportsMeetAthletList();
  },
  methods: {
    /**
     * 清空对象值
     * @param obj
     */
    setNull(obj) {
      this.newAthletesTitle = '';
      for (let key in obj) {
        if (typeof obj[key] == 'number') {
          obj[key] = 0
        } else if (typeof obj[key] == 'string') {
          obj[key] = ''
        } else if (typeof obj[key] == 'object') {
          obj[key] = this.setNull(obj[key]);
        }
      }
      return obj;
    },
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    async GetSportsMeetMultiTypes() {
      const res = await GetSportsMeetMultiTypes();
      this.categorys = [];
      this.genders = [];
      this.progresses = [];
      this.sgroups = [];
      this.deps = [];
      for (let i in res.category) {
        this.categorys.push({ text: res.category[i], value: res.category[i] });
      }
      for (let i in res.gender) {
        this.genders.push({ text: res.gender[i], value: res.gender[i] });
      }
      for (let i in res.progress) {
        this.progresses.push({ text: res.progress[i], value: res.progress[i] });
      }
      for (let i in res.sgroup) {
        this.sgroups.push({ text: res.sgroup[i], value: res.sgroup[i] });
      }
      for (let i in res.dep) {
        this.deps.push({ text: res.dep[i], value: res.dep[i] });
      }
    },
    getTitle() {
      let title = this.gender + '子' + this.sgroup + '组' + this.category + this.new_progress + this.new_group + '组'
      return title
    },
    async beforeClose(action, done) {
      if (action === 'cancel') {
        done();
        return
      }
      if (this.progress == "决赛") {
        Toast("决赛不可晋级")
        return;
      }
      if (this.progress == "复赛") {
        this.new_progress = "决赛"
      }
      let result = this.result;
      let list = "";
      for (let i = 0; i < result.length; i++) {
        if (result[i].new_dc == null || result[i].new_dc.trim() == "") {
          Toast(result[i].sname + "道次不可为空")
          done(false);
          return;
        }
        // result[i].sNum = result[i].snum;
        // delete result[i].title
        // delete result[i].gender
        list += JSON.stringify({
          dep: result[i].dep,
          number: result[i].number,
          sName: result[i].sname,
          sNum: result[i].snum,
          dc: result[i].new_dc,
          types: result[i].types,
        }).toString();
        if (i != result.length - 1) {
          list += '-';
        }
      }
      const res = await SportsMeetPromotion(list, this.gender, this.sgroup, this.category, this.new_progress, this.new_group, this.getTitle());
      if (res.status) {
        done();
        Toast.success('晋级成功');
        return;
      }
      Toast("晋级失败")
      done(false);
      // done(false)
    },

    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("/more");
    }
    ,

    // Popover
    onOperate({ text }) {
      if (text == "运动会报名表") {
        this.actionSheetShow = true;
        return
      }
      if (text == "导出秩序册") {
        this.download1();
        return;
      }
      if (text == "导出号码对照表") {
        this.download2();
        return;
      }
      if (text == "下载数据") {
        this.downloadAll()
        return;
      }
      if (text == "下载当前条件数据") {
        this.downloadAllByCondition()
        return;
      }
      if (text == "添加运动员") {
        this.addAthletesShow = true;
        this.newAthletes = this.setNull(this.newAthletes);
        return;
      }
    }
    ,
    selectedSearchStu(item) {
      this.newAthletes.Athletes = { name: item.sName, num: item.sNum, gender: item.gender };
    },
    async getSportsMeetGroup() {
      let res = await GetSportsMeetGroup(this.category, this.sgroup);
      if(!res.status){
          alert("发生错误")
          return
        }
      let titles = res.title.sort();
      this.items = []
      for (let i = 0; i < titles.length; i++) {
        if (i == 0) {
          this.item = titles[i];
        }
        this.items.push({ text: titles[i], value: titles[i] })
      }

    }
    ,
    async getSportsMeetAthletList() {
      try {
        const res = await GetSportsMeetAthletList(this.gender, this.sgroup, this.category, this.progress);
        if(!res.status){
          alert("该组发生错误")
          return
        }
        let athletList = res.athletList;
        this.athletList = athletList;
      }
      catch (e) {
        alert("该组发生错误")
      }
    }
    ,
    dropdownItemChange() {
      this.result = [];
      this.getSportsMeetGroup();
      this.getSportsMeetAthletList();
    }
    ,
    toggle(index) {
      if (this.athletList[index].pass == 0) {
        Toast("犯规不可晋级")
        return
      }
      this.$refs.checkboxes[index].toggle();
    }
    ,
    download1() {
      let title = "运动会秩序册";
      Dialog.confirm({
        title: '提示',
        message: '确定要下载' + title + '吗'
      }).then(() => {
        var a = document.createElement('a');
        a.target = "_blank";
        let hostname = document.location.hostname;
        if (hostname.indexOf("sports.hhstu.club") != -1) {
          a.href = 'http://' + hostname + "/api/download/sportsMeetProgramDownLoad";
        } else {
          a.href = 'http://' + hostname + ":8080/api/download/sportsMeetProgramDownLoad";
        }
        a.click();
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    downloadAllByCondition() {

      const gender = this.gender;
      const sgroup = this.sgroup;
      const category = this.category;
      const progress = this.progress;
      let title = new Date().toLocaleString() + " " + (gender + "子" + sgroup + "组" + category + progress) + " 运动会数据";

      let condition = `?gender=${gender}&sgroup=${sgroup}&category=${category}&progress=${progress}`;
      Dialog.confirm({
        title: '提示',
        message: '确定要下载' + title + '吗'
      }).then(() => {
        var a = document.createElement('a');
        a.target = "_blank";
        let hostname = document.location.hostname;
        if (hostname.indexOf("sports.hhstu.club") != -1) {
          a.href = 'http://' + hostname + "/api/download/SportsMeetAllDownLoadByConditionController" + condition;
        } else {
          a.href = 'http://' + hostname + ":8080/api/download/SportsMeetAllDownLoadByConditionController" + condition;
        }
        a.click();
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    downloadAll() {
      let title = new Date().toLocaleString() + " 全部运动会数据";
      Dialog.confirm({
        title: '提示',
        message: '确定要下载' + title + '吗'
      }).then(() => {
        var a = document.createElement('a');
        a.target = "_blank";
        let hostname = document.location.hostname;
        if (hostname.indexOf("sports.hhstu.club") != -1) {
          a.href = 'http://' + hostname + "/api/download/SportsMeetAllDownLoadController";
        } else {
          a.href = 'http://' + hostname + ":8080/api/download/SportsMeetAllDownLoadController";
        }
        a.click();
        // on confirm
      }).catch(() => {
        // on cancel
      });
    }
    ,
    download2() {
      let title = "运动员号码对照表";
      Dialog.confirm({
        title: '提示',
        message: '确定要下载' + title + '吗'
      }).then(() => {
        var a = document.createElement('a');
        a.target = "_blank";
        let hostname = document.location.hostname;
        if (hostname.indexOf("sports.hhstu.club") != -1) {
          a.href = 'http://' + hostname + "/api/download/sportsMeet2ProgramDownLoad";
        } else {
          a.href = 'http://' + hostname + ":8080/api/download/sportsMeet2ProgramDownLoad";
        }
        a.click();
        // on confirm
      }).catch(() => {
        // on cancel
      });
    }
    ,
    before_read(file) {
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        Dialog.alert({
          message: '请上传 xlsx或xls 格式文件',
        });
        return false;
      } else if (file.size > 5039264) {
        Dialog.alert({
          message: '文件过大,请保持在5M以内',
        });
        return false;
      }
      return true;
    }
    ,
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      data.append("file", file.file);
      upLoadStuSportsMeet(data).then(res => {
        if (res.status) {
          file.status = 'done';
          file.message = '导入成功';
          Dialog.alert({
            title: '导入成功',
            message: "导入成功",
          });
        } else {
          file.status = 'failed';
          file.message = '导入失败';
          this.repeatability = res.result;
          this.uploadCheck = res.check || [];
        }
      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })

    }
    ,
    delete_file() {
      this.FailStudentList = [];
      this.repeatability = [];
      this.uploadCheck = [];
      return true;
    }
    ,
    select() {
      // if (this.result.length > 8) {
      //   Toast("最多可选择8个")
      //   return
      // }
      this.show = true;
    },
    del() {
      // if (this.progress == '预赛') {
      //   Toast("预赛不可删除")
      //   return
      // }
      this.delList = this.result;
      this.delShow = true;
    },
    selectAllOrNot() {
      let athletList = this.athletList.filter(v => v.pass != 0)
      this.result = (this.result.length == athletList.length ? [] : athletList);
    },
    async clickDel() {
      let list = "";
      const delList = this.delList;
      for (let i = 0; i < delList.length; i++) {
        list += delList[i].id;
        if (i != delList.length - 1) {
          list += "-";
        }
      }
      const res = await DelAthletByIdList(list);
      if (res) {
        Toast.success("删除成功")
        this.delList = [];
        this.result = [];
      } else {
        Toast("删除失败")
      }
      this.getSportsMeetAthletList();
    },
    copyTextToClipboard(text) {
      this.$copyText(text).then(e => {
        Toast("复制成功")
      },
        e => {
          Toast("复制失败")
        })
    },
    async beforeAddAthletesClose(action, done) {
      if (action === 'confirm') {

        if (this.newAthletes.Athletes.name == '') {
          Toast.fail('学生信息不可为空');
          done(false)
          return
        }
        if (this.newAthletes.Athletes.number == undefined) {
          Toast.fail('运动员号码不可为空');
          done(false)
          return
        }
        if (this.newAthletes.daoci <= 0) {
          Toast.fail('学生道次不可为空');
          done(false)
          return
        }
        if (this.newAthletes.dep == '') {
          Toast.fail('参赛单位不可为空');
          done(false)
          return
        }
        if (this.newAthletes.sgroup == '') {
          Toast.fail('项目组别不可为空');
          done(false)
          return
        }
        if (this.newAthletes.category == '') {
          Toast.fail('项目类别不可为空');
          done(false)
          return
        }
        if (this.newAthletesTitle == '') {
          if (this.newAthletes.types == '') {
            Toast.fail('项目类型不可为空');
            done(false)
            return
          }

          if (this.newAthletes.progress == '') {
            Toast.fail('项目进度不可为空');
            done(false)
            return
          }
        }
        let ath = this.newAthletes;
        let title = this.newAthletesTitle;
        if (this.newAthletesTitle == '') {
          title = ath.Athletes.gender + '子' + ath.sgroup + '组' + ath.category + ath.progress + '第' + ath.group_number + '组'
        }

        // sName,sNum,gender,dep,sgroup,types,category,progress,groupNumber,serial,daoci,title
        const res = await AddAthletesController(ath.Athletes.name,
          ath.Athletes.num, ath.Athletes.gender, ath.dep, ath.Athletes.number, ath.sgroup, ath.types == '径赛' ? 'track' : 'field',
          ath.category, ath.progress, ath.group_number, ath.serial, ath.daoci, title);
        if (res) {
          this.Dialoginfo('提示', '添加成功');
          done();
          this.GetSportsMeetMultiTypes();
        } else {
          this.Dialoginfo('提示', '添加失败');
          done(false);
        }
      } else {
        done();
      }
    },
    selectMultiTypes(mt) {
      this.multiType = '';
      this.multiTypeName_tag = mt;
      this.multiTypeShow = true;
      if (mt == 'dep') {
        this.multiTypes = this.deps;
        this.multiTypeName = '参赛单位'
      } else if (mt == 'sgroup') {
        this.multiTypes = this.sgroups;
        this.multiTypeName = '项目组别'
      } else if (mt == 'types') {
        this.multiTypes = [{ text: '径赛', value: '径赛' }, { text: '田赛', value: '田赛' },];
        this.multiTypeName = '项目类型'
      } else if (mt == 'category') {
        this.multiTypes = this.categorys;
        this.multiTypeName = '项目类别'
      } else if (mt == 'progress') {
        this.multiTypes = this.progresses;
        this.multiTypeName = '项目进度'
      }
    },
    async multiTypeShowClose(mt) {
      if (mt == 'dep') {
        this.newAthletes.dep = this.multiType;
      } else if (mt == 'sgroup') {
        this.newAthletes.sgroup = this.multiType;
        // const res = await GetSportsMeetGroup(this.newAthletes.category, this.newAthletes.sgroup);
        this.newAthletesTitles = res.title;
      } else if (mt == 'types') {
        this.newAthletes.types = this.multiType;
      } else if (mt == 'category') {
        this.newAthletes.category = this.multiType;
        const res = await GetSportsMeetGroup(this.newAthletes.category, this.newAthletes.sgroup);
        if(!res.status){
          alert("发生错误")
          return
        }
        this.newAthletesTitles = res.title;
      } else if (mt == 'progress') {
        this.newAthletes.progress = this.multiType;
      }
    },

  }
}
</script>

<style scoped>
.content {
  padding: 16px 16px 160px;
}

.promotion {
  position: fixed;
  right: 65px;
  top: 0px;
  z-index: 999 !important;
}

.delete {
  position: fixed;
  right: 66px;
  bottom: 70px;
  z-index: 999 !important;
}

.selectAllOrNot {
  position: fixed;
  right: 66px;
  bottom: 30px;
  z-index: 999 !important;
}

.classesContent {
  padding: 16px 16px 360px;
}

.classesSelected {
  color: #7dbfff;
  font-weight: bold;
}
</style>
